import React from 'react'
import BaseSelectBoxWrapper from './BaseSelectBoxWrapper'
import BaseSelectBox from './BaseSelectBox'

interface PropsType {
  children: React.ReactNode
  onChange: (e: any) => void
  // TODO: HTMLのvalue属性はstring型なので最終的にnumberは削除する
  value: string | number | null
  ariaLabel?: string
}

const EmphasisSelectBox = (props: PropsType) => {
  const { children, onChange, value, ariaLabel } = props
  const safetyValue = value ?? '0'
  return (
    <BaseSelectBoxWrapper $capColor="#e02b2b">
      <BaseSelectBox value={safetyValue} onChange={onChange} aria-label={ariaLabel}>
        {children}
      </BaseSelectBox>
    </BaseSelectBoxWrapper>
  )
}

export default EmphasisSelectBox
